// === DRIPARA Marquee: Smooth Drag + Hover Stop ===
document.addEventListener("DOMContentLoaded", () => {
  const marquee = document.getElementById("marquee");
  const content = document.getElementById("marquee-content");
  if (!marquee || !content) return;

  const baseText = "FREE SHIPPING OVER 150€";
  const repeatCount = 1000;
  const spacer = "        "; // velik razmik med ponovitvami
  content.textContent = (baseText + spacer).repeat(200); // zelo visoko število, da deluje kot 'infinity'



  let animationFrame;
  let paused = false;
  let isDragging = false;
  let startX = 0;
  let position = 0;
  let velocity = -1.4; // začetna hitrost v levo
  const naturalSpeed = -0.95;
  const returnAccel = 0.05;

  function animate() {
    if (!paused && !isDragging) {
      position += velocity;
      content.style.transform = `translateX(${position}px)`;
    }
    animationFrame = requestAnimationFrame(animate);
  }

  animate();

  // Hover = pavza
  marquee.addEventListener("mouseenter", () => paused = true);
  marquee.addEventListener("mouseleave", () => paused = false);

  // Drag logika
  marquee.addEventListener("mousedown", e => {
    isDragging = true;
    startX = e.clientX;
    marquee.style.cursor = "grabbing";
  });

  window.addEventListener("mouseup", () => {
    if (isDragging) {
      isDragging = false;
      marquee.style.cursor = "grab";
    }
  });

  window.addEventListener("mousemove", e => {
    if (!isDragging) return;
    const deltaX = e.clientX - startX;
    startX = e.clientX;
    position += deltaX;
    velocity = deltaX;
    content.style.transform = `translateX(${position}px)`;
  });

  // Naraven prehod nazaj na osnovno hitrost
  setInterval(() => {
    if (!isDragging && !paused) {
      velocity += (naturalSpeed - velocity) * returnAccel;
    }
  }, 16);
});
